const postalValue = value =>
  value
    .replace('.', '')
    .replace('-', '')
    .replace(/^(\d{2})(\d{3})(\d{3})$/g, '$1.$2-$3');

export default postalValue;
